import axiosInstance from '@/utils/axiosInstance.js'
import SERVICES from '@/utils/servicesUtil.js'
import Qs from 'qs'

const getAutomation = (organizationId, workflowId, params) =>
  axiosInstance.get(`${SERVICES.AUTOMATION}/${organizationId}/workflow/${workflowId}`, { params })

const getAutomations = (organizationId, params) =>
  axiosInstance.get(`${SERVICES.AUTOMATION}/${organizationId}/workflow`, {
    params,
    paramsSerializer: (params) => {
      return Qs.stringify(params, { arrayFormat: 'repeat' })
    },
  })

const patchAutomation = (organizationId, workflowId, params) =>
  axiosInstance.patch(`${SERVICES.AUTOMATION}/${organizationId}/workflow/${workflowId}`, params)

const postAutomation = (organizationId, params) => axiosInstance.post(`${SERVICES.AUTOMATION}/${organizationId}/workflow/`, params)

const enableAutomation = (organizationId, workflowId) => axiosInstance.patch(`${SERVICES.AUTOMATION}/${organizationId}/workflow/${workflowId}/enable`)

const disableAutomation = (organizationId, workflowId) => {
  return axiosInstance.patch(`${SERVICES.AUTOMATION}/${organizationId}/workflow/${workflowId}/disable`)
}
const removeAutomation = (organizationId, workflowId) => {
  return axiosInstance.delete(`${SERVICES.AUTOMATION}/${organizationId}/workflow/${workflowId}`)
}

const finishAutomation = (organizationId, workflowId, params) =>
  axiosInstance.post(`${SERVICES.AUTOMATION}/${organizationId}/workflow/${workflowId}/finish`, params)

export default {
  getAutomation,
  getAutomations,
  postAutomation,
  patchAutomation,
  enableAutomation,
  disableAutomation,
  removeAutomation,
  finishAutomation,
}
